import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { InputBox } from "../../components/CustomWidgets/InputBox";
import upload from "../../assets/Images/Uploadminimalistic.svg";
// import {Image}  from "antd";
import axiosInstance from "../../AxiosInstance";
import Notification from "../../modals/Notification";
import UpdatedProfile from "../../modals/UpdatedProfile"; // Import the UpdatedProfile modal
import UploadMediaonly from "../upload-imageonly";
import { Button, Image, Modal } from "antd";
import "../../styles.css";
import {
  BusinessProofSchema,
  profileBusinessProofSchema,
} from "../validationSchema";
import { useNavigate } from "react-router";
import { URLS } from "../../API/API endpoints";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  GetRetailerDocs,
  UpdateRetailerDetails,
} from "../../API  Functions/ProfileFunctions";
import UploadMedia from "../upload-media";
import UploadPDF from "../upload-pdf";
import { checkPermission } from "../../Utils/permissionHelper";
import UploadBusinessMedia from "../uploadBuinessProofs";
import UploadDocuments from "../uploadProfileBusinessProof";

/**
 * Utilities
 */

// normalize backend base64 into valid data URI
const fixBase64DataUri = (raw = "") => {
  if (!raw || typeof raw !== "string") return "";

  const lower = raw.toLowerCase();

  // If it already starts with data:, try to sanitize spacing/commas
  if (lower.startsWith("data:")) {
    // ensure there's a comma after base64,
    const parts = raw.split(/base64[,]?/i);
    if (parts.length >= 2) {
      const payload = parts.slice(1).join("base64");
      const mimePartMatch = parts[0].match(/^data:([^;]+);?/i);
      const mime = mimePartMatch ? mimePartMatch[1] : "application/octet-stream";
      return `data:${mime};base64,${payload.replace(/^,/, "")}`;
    }
    return raw;
  }

  // handle malformed prefixes like "dataapplication/pdfbase64..." or "dataimage/jpegbase64..."
  if (lower.includes("pdf")) {
    const payload = raw.split(/base64[,]?/i).pop() || raw;
    return `data:application/pdf;base64,${payload.replace(/^,/, "")}`;
  }

  if (lower.includes("jpeg") || lower.includes("jpg")) {
    const payload = raw.split(/base64[,]?/i).pop() || raw;
    return `data:image/jpeg;base64,${payload.replace(/^,/, "")}`;
  }

  if (lower.includes("png")) {
    const payload = raw.split(/base64[,]?/i).pop() || raw;
    return `data:image/png;base64,${payload.replace(/^,/, "")}`;
  }

  // fallback: if it contains "base64" try to use whatever comes after
  if (lower.includes("base64")) {
    const payload = raw.split(/base64[,]?/i).pop() || raw;
    return `data:application/octet-stream;base64,${payload.replace(/^,/, "")}`;
  }

  return raw;
};

// detect file type from raw or fixed base64 string
const detectFileType = (base64) => {
  if (!base64 || typeof base64 !== "string") return "unknown";

  const str = base64.toLowerCase();

  // Fix backend broken formats before checking
  // Example: "dataimage/jpegbase64/.."
  if (str.includes("image/jpeg") || str.includes("/9j/")) return "jpeg"; // JPEG base64 always starts with /9j/
  if (str.includes("image/png") || str.startsWith("iVBORw".toLowerCase())) return "png";
  if (str.includes("application/pdf") || str.startsWith("JVBER".toLowerCase())) return "pdf"; // PDF starts with `%PDF` → JVBER base64

  return "unknown";
};

const BusinessProof = ({ payload, onDataSubmit, data }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [notification, setnotification] = useState(false);
  const [showUpdatedProfile, setShowUpdatedProfile] = useState(false);
  const [restricted, setrestricted] = useState(true);
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [base64Images, setBase64Images] = useState([]);
  const [uploadedPdf, setuploadedPdf] = useState([]);
  const isGinne = useSelector(
    (state) => state?.geneLoginReducer?.isGinneLogin
  );

  // modal state
  const [pdfModalOpen, setPdfModalOpen] = useState(false);
  const [pdfModalSrc, setPdfModalSrc] = useState("");
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageModalSrc, setImageModalSrc] = useState("");

  // load initial values when data or user changes
  useEffect(() => {
    // ensure formik exists before calling setValues (formik is defined below)
    if (formik) {
      formik.setValues({
        commercial_num: data?.retailer_details?.company_registry || "",
        tax_card_num: data?.retailer_details?.tax_card_number || "",
        national_id: data?.retailer_details?.manager_id || "",
      });
    }
    setBase64Images([]);
    fetchRetailerDocs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, user_id]);

  const fetchRetailerDocs = async () => {
    try {
      const response = await GetRetailerDocs(user_id);
      // console.log("DOCUMENTS response", response);
      if (response?.status_code === 200) {
        const documents = response?.response || [];

        const items = [];
        documents.forEach((doc) => {
          if (
            doc.document &&
            [
              "commercial_registry_certificate",
              "tax_card",
              "national_id",
              "manageridurl",
            ].includes(doc.filename)
          ) {
            // push raw; we'll fix when showing
            items.push({ filename: doc.filename, attachment: doc.document });
          }
        });

        setBase64Images(items);
      }
    } catch (error) {
      console.error("Error fetching retailer documents:", error);
    }
  };

  const formik = useFormik({
    initialValues: {
      commercial_num: data?.retailer_details?.company_registry || "",
      commercial_num_url: "",
      tax_card_num: data?.retailer_details?.tax_card_number || "",
      tax_card_num_url: "",
      national_id: data?.retailer_details?.manager_id || "",
      national_id_url: "",
    },
    // validationSchema: profileBusinessProofSchema,
    onSubmit: async (values, { resetForm }) => {
      if (!checkPermission("/settings/profile", isGinne)) {
        return;
      }
      const apipayload = {
        user_id: user_id,
        manager_id: values.national_id,
        tax_card_number: values.tax_card_num,
        company_registry: values.commercial_num,
      };

      try {
        if (uploadedPdf.length > 0) {
          for (const file of uploadedPdf) {
            if (file.attachment) {
              const uploadPayload = {
                user_id: user_id,
                filename: file.filename,
                attachment: file.attachment,
              };
              const uploadResponse = await axiosInstance.post(
                URLS.UPLOAD_RETAILER_DOCUMENTS,
                uploadPayload
              );

              if (uploadResponse.status !== 200) {
                throw new Error("Failed to upload document: " + file.filename);
              }
            }
          }
        }

        const response = await UpdateRetailerDetails(apipayload);
        if (response?.status === "Update Successfully") {
          setnotification(true);
          setrestricted(true);
          setShowUpdatedProfile(true);
          // refetch to show updated docs
          fetchRetailerDocs();
        }
      } catch (error) {
        console.error("submit error", error);
      }
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    formik.handleSubmit(e);
  };

  // When UploadPDF (or other upload component) returns the generated url
  // We expect urlgenerated to be called as: urlgenerated({ url: "<base64string>" }, keyname)
  const handleurlgenerated = (values, keyname) => {
    setrestricted(false);
    // if UploadPDF provides values.url (base64), store to formik and preview list
    formik.setFieldValue(keyname, values.url);

    setBase64Images((prev) => {
      const updatedImages = [...prev];
      // find first instance with same filename
      const index = updatedImages.findIndex((img) => img.filename === keyname);
      if (index !== -1) {
        // replace that instance
        updatedImages[index] = { filename: keyname, attachment: values.url };
      } else {
        updatedImages.push({ filename: keyname, attachment: values.url });
      }
      return updatedImages;
    });

    // also add to uploaded queue for submit
    setuploadedPdf((prev) => {
      const updated = [...prev];
      const idx = updated.findIndex((p) => p.filename === keyname);
      const entry = { filename: keyname, attachment: values.url };
      if (idx !== -1) updated[idx] = entry;
      else updated.push(entry);
      return updated;
    });
  };

  // helpers to get files per section
  const commercialFiles = base64Images.filter(
    (img) => img.filename === "commercial_registry_certificate"
  );
  const nationalIdFiles = base64Images.filter(
    (img) => img.filename === "national_id"
  );
  const taxCardFiles = base64Images.filter(
    (img) => img.filename === "tax_card"
  );
  const managerIdFiles = base64Images.filter(
    (img) => img.filename === "manageridurl"
  );

  // open image modal
  const openImageModal = (rawAttachment) => {
    const src = fixBase64DataUri(rawAttachment);
    setImageModalSrc(src);
    setImageModalOpen(true);
  };

  // open pdf modal
  const openPdfModal = (rawAttachment) => {
    const src = fixBase64DataUri(rawAttachment);
    setPdfModalSrc(src);
    setPdfModalOpen(true);
  };

  // Render a single file preview (image or pdf)
  const RenderFilePreview = ({ file, index, downloadNamePrefix }) => {
    const fixed = fixBase64DataUri(file?.attachment || "");
    const type = detectFileType(file?.attachment || fixed);

    if (type === "jpeg" || type === "png") {
      // image inline + modal on click (Images: both inline + modal)
      return (
        <div
          className="flex items-center gap-3 p-2 bg-gray-100 rounded-md shadow-sm"
          style={{ width: "100%" }}
        >
          <div className="flex items-center gap-3">
            <div
              style={{ cursor: "pointer" }}
              onClick={() => openImageModal(file.attachment)}
            >
              {/* antd Image for built-in preview disabled (we use our modal) */}
              <Image
                src={fixed}
                alt={`img-${index}`}
                width={80}
                height={60}
                style={{ objectFit: "cover", borderRadius: 6 }}
                preview={false}
              />
            </div>
            <div className="flex flex-col">
              {/* <span className="text-sm text-gray-700 break-all">
                {downloadNamePrefix}_{index + 1}
              </span> */}
              <div className="mt-1 flex gap-3 items-center">
                <a
                  href={fixed}
                  download={`${downloadNamePrefix}_${index + 1}.jpg`}
                  className="text-xs text-gray-500 hover:underline"
                >
                  {t("Download")}
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (type === "pdf") {
      // PDF: thumbnail + "View PDF" button opens modal with iframe
      return (
        <div
          className="flex items-center justify-between p-2 bg-gray-100 rounded-md shadow-sm"
          style={{ width: "100%" }}
        >
          <div className="flex items-center gap-3">
            <div style={{ width: 48, height: 60 }} className="flex items-center justify-center bg-white rounded border">
              {/* simple pdf icon */}
              <svg className="w-6 h-6 text-gray-600" viewBox="0 0 24 24" fill="currentColor">
                <path d="M6 2h7l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
              </svg>
            </div>
            <div className="flex flex-col">
              {/* <span className="text-sm text-gray-700">{downloadNamePrefix}_{index + 1}.pdf</span> */}
              <div className="mt-1 flex gap-3 items-center">
                <button
                  type="button"
                  onClick={() => openPdfModal(file.attachment)}
                  className="text-sm text-blue-600 hover:underline"
                >
                  {t("View PDF")}
                </button>
                <a
                  href={fixed}
                  download={`${downloadNamePrefix}_${index + 1}.pdf`}
                  className="text-xs text-gray-500 hover:underline"
                >
                  {t("Download")}
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // unknown type
    return (
      <div className="flex items-center gap-3 p-2 bg-gray-100 rounded-md shadow-sm">
        <span className="text-sm text-gray-600">{t("Unsupported file")}</span>
      </div>
    );
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="font-normal text-sm text-[#5c5c5c] flex flex-col md:flex-row gap-4 gap-x-3 mt-6">
          {/* Commercial Registry Column */}
          <div className="w-full md:w-[280px] leading-[0px]">
            <InputBox
              name="commercial_num"
              label={t("commercial_registry_number")}
              placeholder="000000000"
              maxLength={14}
              onChange={(val) => {
                formik.handleChange(val);
                setrestricted(false);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.commercial_num}
              error={formik.errors.commercial_num}
              touched={formik.touched.commercial_num}
            />
            {formik.touched.commercial_num && formik.errors.commercial_num && (
              <div className="text-red text-xs">
                {formik.errors.commercial_num}
              </div>
            )}
            {formik.touched.commercial_num && formik.values.commercial_num_url !== "" &&
              formik.values.commercial_num === "" && (
                <div className="text-red text-xs">
                  {("Please enter Commercial Registry Number")}{" "}
                </div>
              )}

            <div className="w-full md:w-[280px] mt-2">
              <div className="flex flex-col rounded-lg border border-gray-900/25 px-4 py-3 bg-white">
                <div className="flex flex-col justify-center gap-3 mb-4">
                  {commercialFiles.length > 0 ? (
                    commercialFiles.map((file, index) => (
                      <RenderFilePreview
                        key={index}
                        file={file}
                        index={index}
                        downloadNamePrefix={"commercial_registry_certificate"}
                      />
                    ))
                  ) : (
                    <div className="flex items-center justify-center w-full h-16 bg-gray-200 rounded-md">
                      <svg
                        className="h-10 w-10 text-gray-400"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
                        />
                      </svg>
                      <span className="text-gray-500 ms-2">{t("No files uploaded")}</span>
                    </div>
                  )}
                </div>

                <div className="flex justify-center ">
                  <label
                    htmlFor="file-upload"
                    className="flex w-full justify-center items-center cursor-pointer rounded-md bg-white inline border border-primaryBlue py-2 px-4 text-white font-semibold hover:bg-gray-100 transition duration-200"
                  >
                    <UploadDocuments
                      onfileAdd="commercial_registry_certificate"
                      urlgenerated={handleurlgenerated}
                      multiple={false}
                      message={(message) => !message}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* National / Manager ID Column */}
          <div className="w-full md:w-[280px] leading-[0px]">
            <InputBox
              label={t("managerid")}
              name="national_id"
              placeholder="000000000"
              maxLength={14}
              onChange={(val) => {
                formik.handleChange(val);
                setrestricted(false);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.national_id}
              error={formik.errors.national_id}
              touched={formik.errors.national_id}
            />
            {formik.touched.national_id && formik.errors.national_id && (
              <div className="text-red text-xs">
                {formik.errors.national_id}
              </div>
            )}
            {formik.touched.national_id && formik.values.national_id_url !== "" &&
              formik.values.national_id === "" && (
                <div className="text-red text-xs">
                  {t("Please enter National ID")}{" "}
                </div>
              )}

            <div className="w-full md:w-[280px] mt-2">
              <div className="flex flex-col rounded-lg border border-gray-900/25 px-4 py-3 bg-white">
                <div className="flex flex-col justify-center gap-3 mb-4">
                  {managerIdFiles.length > 0 ? (
                    managerIdFiles.map((file, index) => (
                      <RenderFilePreview
                        key={index}
                        file={file}
                        index={index}
                        downloadNamePrefix={"manager_id"}
                      />
                    ))
                  ) : (
                    <div className="flex items-center justify-center w-full h-16 bg-gray-200 rounded-md">
                      <svg
                        className="h-10 w-10 text-gray-400"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
                        />
                      </svg>
                      <span className="text-gray-500 ms-2">{("No files uploaded")}</span>
                    </div>
                  )}
                </div>

                <div className="flex justify-center ">
                  <label
                    htmlFor="file-upload"
                    className="flex w-full justify-center items-center cursor-pointer rounded-md bg-white inline border border-primaryBlue py-2 px-4 text-white font-semibold hover:bg-gray-100 transition duration-200"
                  >
                    <UploadDocuments
                      foldername={"store_app_UAT"}
                      onfileAdd={"national_id"}
                      filename={"national_id"}
                      urlgenerated={handleurlgenerated}
                      setBase64Images={setBase64Images}
                      setuploadedPdf={setuploadedPdf}
                      imageurl={formik.values.national_id}
                      message={(message) => !message}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>

          {/* Tax Card Column */}
          <div className="w-full md:w-[280px] leading-[0px]">
            <InputBox
              label={t("taxcard_number")}
              name="tax_card_num"
              placeholder="000000000"
              maxLength={9}
              onChange={(val) => {
                formik.handleChange(val);
                setrestricted(false);
              }}
              onBlur={formik.handleBlur}
              value={formik.values.tax_card_num}
              error={formik.errors.tax_card_num}
              touched={formik.touched.tax_card_num}
            />
            {formik.touched.tax_card_num && formik.errors.tax_card_num && (
              <div className="text-red text-xs">
                {formik.errors.tax_card_num}
              </div>
            )}
            {formik.touched.tax_card_num && formik.values.tax_card_num_url !== "" &&
              formik.values.tax_card_num === "" && (
                <div className="text-red text-xs">
                  {("Please enter Tax card number")}{" "}
                </div>
              )}

            <div className="w-full md:w-[280px] mt-2">
              <div className="flex flex-col rounded-lg border border-gray-900/25 px-4 py-3 bg-white">
                <div className="flex flex-col justify-center gap-3 mb-4">
                  {taxCardFiles.length > 0 ? (
                    taxCardFiles.map((file, index) => (
                      <RenderFilePreview
                        key={index}
                        file={file}
                        index={index}
                        downloadNamePrefix={"tax_card"}
                      />
                    ))
                  ) : (
                    <div className="flex items-center justify-center w-full h-16 bg-gray-200 rounded-md">
                      <svg
                        className="h-10 w-10 text-gray-400"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
                        />
                      </svg>
                      <span className="text-gray-500 ms-2">{t("No files uploaded")}</span>
                    </div>
                  )}
                </div>

                <div className="flex justify-center ">
                  <label
                    htmlFor="file-upload"
                    className="flex w-full justify-center items-center cursor-pointer rounded-md bg-white inline border border-primaryBlue py-2 px-4 text-white font-semibold hover:bg-gray-100 transition duration-200"
                  >
                    <UploadDocuments
                      foldername={"store_app_UAT"}
                      onfileAdd={"tax_card_num_url"}
                      urlgenerated={handleurlgenerated}
                      filename={"tax_card"}
                      setBase64Images={setBase64Images}
                      setuploadedPdf={setuploadedPdf}
                      imageurl={formik.values.tax_card_num_url}
                      message={(message) => !message}
                    />
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className=" flex gap-5 mx-3 md:mx-7 mt-16 mb-5">
          <button
            type="submit"
            className={`w-[180px] h-[45px] ${restricted ? "bg-primaryBluedisabled" : "bg-primaryBlue"
              } text-white rounded-lg font-semibold `}
            disabled={restricted}
          >
            {t("update_and_save")}
          </button>
          <Button
            className="w-[180px] h-[45px] text-primaryBlue font-semibold rounded-lg inline border border-primaryBlue"
            onClick={() => {
              formik?.setValues({
                commercial_num: data?.retailer_details?.company_registry || "",
                tax_card_num: data?.retailer_details?.tax_card_number || "",
                national_id: data?.retailer_details?.manager_id || "",
              });
              fetchRetailerDocs();
            }}
          >
            {t("cancel")}
          </Button>
        </div>
      </form>

      {notification && (
        <Notification
          message={t("Business Proof  Details Updated Sucessfully")}
          onClose={() => setnotification(false)}
        />
      )}

      {showUpdatedProfile && (
        <UpdatedProfile
          onClose={() => setShowUpdatedProfile(false)}
          message={t("Business Proof Details")}
        />
      )}

      {/* PDF Modal */}
      <Modal
        open={pdfModalOpen}
        onCancel={() => { setPdfModalOpen(false); setPdfModalSrc(""); }}
        footer={null}
        width={"80%"}
        style={{ top: 20 }}
        bodyStyle={{ height: "80vh", padding: 0 }}
      >
        {pdfModalSrc ? (
          <iframe
            title="pdf-preview"
            src={pdfModalSrc}
            style={{ width: "95%", height: "95%", border: 0 }}
          />
        ) : (
          <div className="p-4">{t("No PDF to preview")}</div>
        )}
      </Modal>

      {/* Image Modal */}
      <Modal
        open={imageModalOpen}
        onCancel={() => { setImageModalOpen(false); setImageModalSrc(""); }}
        footer={null}
        width={"60%"}
        style={{ top: 40 }}
        bodyStyle={{ padding: 12, textAlign: "center" }}
      >
        {imageModalSrc ? (
          <img src={fixBase64DataUri(imageModalSrc)} alt="preview" style={{ maxWidth: "100%", maxHeight: "80vh", borderRadius: 8 }} />
        ) : (
          <div>{t("No image")}</div>
        )}
      </Modal>
    </>
  );
};

export default BusinessProof;